class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.labelShowMore = this.querySelector(".label-show-more");
    this.labelShowLess = this.querySelector(".label-show-less");
    this.isShowingMore = false;

    this.init();
  }

  init() {
    if (this.button) {
      this.button.addEventListener("click", this.toggleShowMore.bind(this));
    }
  }

  toggleShowMore() {
    this.isShowingMore = !this.isShowingMore;

    // Find the parent details element and then the facets wrap
    const detailsElement = this.closest("details");
    if (!detailsElement) return;

    const facetsWrap = detailsElement.querySelector(".facets-wrap");
    if (!facetsWrap) return;

    // Get all items that should be shown/hidden
    const showMoreItems = facetsWrap.querySelectorAll(".show-more-item");

    if (this.isShowingMore) {
      // Show more items
      showMoreItems.forEach((item) => {
        item.classList.remove("hidden");
      });

      // Update button labels
      if (this.labelShowMore) this.labelShowMore.classList.add("hidden");
      if (this.labelShowLess) this.labelShowLess.classList.remove("hidden");

      // Add class to wrap for styling
      facetsWrap.classList.add("more-shown");
    } else {
      // Hide extra items
      showMoreItems.forEach((item) => {
        item.classList.add("hidden");
      });

      // Update button labels
      if (this.labelShowMore) this.labelShowMore.classList.remove("hidden");
      if (this.labelShowLess) this.labelShowLess.classList.add("hidden");

      // Remove class from wrap
      facetsWrap.classList.remove("more-shown");
    }
  }
}

// Register the custom element
if (!customElements.get("show-more-button")) {
  customElements.define("show-more-button", ShowMoreButton);
}
